import { createFileRoute } from '@tanstack/react-router';

import { PlatformUserListScreen } from '@/features/users/components/platform/UserListScreen';
import { requirePermission } from '@/lib/guards';

export const Route = createFileRoute('/_staff/admin/platform/users/')({
  beforeLoad: () => {
    requirePermission('user:read');
  },
  component: PlatformUserListScreen,
  staticData: { crumb: 'Users' },
});
